import { NgModule, Optional, SkipSelf } from '@angular/core';
import { throwIfAlreadyLoaded } from '@core/module-import-guard';
import { environment } from '@env/environment';
import { API_BASE_URL } from './AffinisDIDApiClient';
import { IdentityClient } from './formulare.api';

const PROVIDERS = [
  { provide: API_BASE_URL, useFactory: () => environment.baseUrl },
  IdentityClient,
];

@NgModule({
  declarations: [],
  imports: [],
  providers: [...PROVIDERS],
})
export class FormulareModule {
  public constructor(@Optional() @SkipSelf() parentModule: FormulareModule) {
    throwIfAlreadyLoaded(parentModule, 'FormulareModule');
  }
}
